import React from 'react';

// Placeholder Images 
const BANNER_IMAGE = "https://wallpapers.com/images/hd/earth-day-broken-sphere-dc81k2ppgnqs2koj.jpg"; 
// Using the green theme color
const PRIMARY_COLOR = '#4f6a39'; 

// Data for the linear plan section, matching the original site's list
const plansList = [
    {
        title: 'Vermicomposting Centre Across India',
        description: 'In our mission to spread awareness and make vermicomposting available across India, we are planning to set up Vermicomposting Centers across India. In this, we will collaborate with interested people who want to set up their farms.',
    },
    {
        title: 'Charekha India Franchise',
        description: 'We are also opening up a franchise of Charekha India with all the best processes and best practices.',
    },
    {
        title: 'Zero-waste integrated farming system',
        description: 'We are moving toward a Zero waste farming system, to make full-fledged organic farming for Healthy Nation.',
    },
    {
        title: 'Permaculture Model',
        description: 'Permaculture is the development of agricultural ecosystems intended to be sustainable and self-sufficient. At Charekha India have the vision to make a model worth duplicating across the globe.',
    },
    {
        title: 'Organic Farming Courses',
        description: 'To spread the knowledge across with ease, we will be setting up online courses in various organic farming techniques and methods.',
    },
];

// Component for a single plan item (simple heading + paragraph)
const SimplePlanItem: React.FC<{ plan: typeof plansList[0] }> = ({ plan }) => {
    return (
        <div className="mb-8 border-l-4 pl-4" style={{ borderColor: PRIMARY_COLOR }}> {/* Added border for visual separation */}
            {/* Scaled text: 2xl -> lg/xl */}
            <h4 className="text-xl sm:text-2xl font-bold text-gray-800 mb-2 mt-4" style={{ color: PRIMARY_COLOR }}>
                {plan.title}
            </h4>
            {/* Scaled text: base -> sm/base */}
            <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
                {plan.description}
            </p>
        </div>
    );
};


const FuturePlanPageExactMatch: React.FC = () => {
    
    return (
        <div className="bg-white mt-32">
            
            {/* 1. Header/Banner - Responsive Height and Text Size */}
           <div 
                // Adjusted height for better mobile look: h-72 -> h-64, md:h-92 -> sm:h-80
                className="relative bg-cover bg-center h-64 sm:h-80 flex items-center justify-start px-4 sm:px-10" 
                style={{ backgroundImage: `url(${BANNER_IMAGE})` }}
            >
                {/* Dark overlay optional, added slightly more contrast for readability */}
                <div className="absolute inset-0 bg-black opacity-40"></div>
                
                {/* Scaled text: 4xl -> 3xl/5xl */}
                <h1 className="relative text-3xl sm:text-5xl font-extrabold text-white z-10 uppercase tracking-tight pb-0 sm:pb-8">
                    FUTURE PLANS
                </h1>
            </div>


            {/* 2. Main Content Area (Introduction + Plans) - Responsive Padding */}
            <div className="py-12 sm:py-20 px-4 sm:px-8 bg-white">
                <div className="max-w-7xl mx-auto text-gray-700">
                    
                    {/* Introduction Text & Image Block - Responsive Stacking */}
                    {/* Used flex-col for mobile, md:flex for tablet/desktop */}
                    <div className="flex flex-col md:flex-row md:space-x-12 mb-12">
                        
                        <div className="md:w-3/5">
                            {/* Scaled text: base -> sm/base */}
                            <p className="mb-4 text-sm sm:text-base">
                                Being in this field for such a long time encourages us to do more and more into Organic. Today we can see fruitful results from all our efforts in the last 10 years.
                            </p>
                            <p className="mb-4 text-sm sm:text-base">
                                As we are receiving vermicomposting enquiries across India. Training enquiries across the globe and people are also connecting from many other domains to contribute towards our mother earth.
                            </p>
                            <p className="mb-4 font-semibold text-sm sm:text-base">
                                We are presenting here a few of our current and future initiatives and plan to achieve our mission of Healthy Nation & Organic World.
                            </p>
                            <p className="mb-4 text-sm sm:text-base">
                                Our main objective is to spread awareness of vermiculture, and organic farming and to connect more people to the cause and also to create a successful permaculture model which can be replicated to scale and benefit millions.
                            </p>
                             <p className="text-xs sm:text-sm italic mt-6 border-l-4 pl-4" style={{ borderColor: PRIMARY_COLOR }}>
                                Vermiculture is a practice which will help out peoples to mitigate their own organic waste and also help people to avoid chemical fertilizers and lead a chemical free healthy life.
                                Whereas Permaculture approaches to land management and settlement design that adopts arrangements observed in flourishing natural ecosystems. It includes a set of design principles derived using whole-systems thinking. It applies these principles in fields such as regenerative agriculture, town planning, rewilding, and community resilience.
                            </p>
                        </div>

                        {/* Image Collage (Hexagon Grid) - Ensured it centers and scales */}
                        <div className="md:w-2/5 flex items-center justify-center mt-8 md:mt-0">
                            <div className="w-48 h-48 sm:w-64 sm:h-64 flex items-center justify-center text-gray-500 italic ">
                                <img src="https://e7.pngegg.com/pngimages/135/717/png-clipart-vermicompost-soil-green-manure-fertilisers-organic-farm-grass-agriculture-thumbnail.png" alt="Future Plans Visual" className='w-full h-full object-contain' />
                            </div>
                        </div>

                    </div>
                    
                    {/* Divider for Visual Separation */}
                    <hr className="my-8 sm:my-12 border-t-2 border-gray-200" />

                    {/* Linear Plan Section - Uses the responsive SimplePlanItem */}
                    <div className="mt-8 sm:mt-12">
                        <h3 className="text-2xl sm:text-3xl font-bold text-gray-800 mb-8" style={{ color: PRIMARY_COLOR }}>
                            Key Initiatives & Future Road Map
                        </h3>
                        {plansList.map((plan, index) => (
                            <SimplePlanItem key={index} plan={plan} />
                        ))}
                    </div>

                </div>
            </div>
            
        </div>
    );
};

export default FuturePlanPageExactMatch;